import log from 'client/lib/log';

import {
  SR_API_ACTION_ADMIN_UPDATE_ALL_LISTINGS,
} from 'api/actionTypes';

export default async function updateAllListings({ apiClient }) {
  try {
    await apiClient.post(SR_API_ACTION_ADMIN_UPDATE_ALL_LISTINGS);
  }
  catch (error) {
    log.error(error);
  }
}
